import React, { useContext, useState } from "react";

import NewButton from "./NewButton";
import "./PopUpModal.css";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { FormTextInput } from "../Components/FormTextInput";
import { NotificationContext } from "../Context/NotificationContext";
import { firestore } from "../firebase.config";

const generateCouponCode = (length = 12) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let coupon = "";
  for (let i = 0; i < length; i++) {
    coupon += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return coupon;
};

const AddEditCouponPopUp = ({ title, deleteBtn, couponData, sendIcon, disableBtn,
  onClose, showClose = true, alignLeft,
}) => {
  const { showNotification } = useContext(NotificationContext);
  const [discountCode, setDiscountCode] = useState(couponData.code || '');
  const [discount, setDiscount] = useState(couponData.discount || '');
  const [usage, setUsage] = useState(couponData.uses || '');
  const [name, setName] = useState(couponData.name || '');
  const [email, setEmail] = useState(couponData.email || '');
  const [submitBtn, setSubmitBtn] = useState(title);
  const handleGenerateDiscount = () => {
    setDiscountCode(generateCouponCode());
  }
  const onChangeDiscount = (value) => {
    // const value = e.target.value;

    var reg = /^[0-9]+\.?[0-9]{0,3}$/;

    if (value === "" || reg.test(value)) {
      console.log(value)
      setDiscount(value);
    }
  };

  const onChangeUsage = (value) => {

    var reg = /^[0-9]+\.?[0-9]{0,3}$/;

    if (value === "" || reg.test(value)) {
      setUsage(value);
    }
  };

  const onChangeName = (value) => {
      setName(value);
  };
  const onChangeEmail = (value) => {
      setEmail(value);
  };

  const btnAddCoupon = async () => {
    if (discount > 100) {
      showNotification("Error", "Discount is greater than 100, please add discount less than 100.", "error");
      return;
    }

    setSubmitBtn(title === "Edit Coupon" ? "Editing..." : "Adding...")

    const couponRef = firestore.collection("coupons");

    const existingCoupon = await couponRef.where("code", "==", discountCode).get();
    
    if (!existingCoupon.empty && !couponData?.id) {
      setSubmitBtn(title);
      showNotification("Error", "A coupon with this code already exists. Please use a different code.", "error");
      return; 
    }

    try {
      const updateData = {
        code: discountCode,
        discount: discount,
        active: true,
        uses: usage ? parseInt(usage, 10) : 0,
        timestamp: Date.now(),
        name: name,
        email: email
      };


      if (couponData?.id) {
        
        await firestore.collection("coupons").doc(couponData.id).update(updateData).then(() => {
          showNotification("Success", "New Coupon Update successfully!", "success");
          setSubmitBtn(title);
          onClose();
        });

      } else {
        
        await firestore.collection("coupons").add(updateData).then(() => {
          showNotification("Success", "New Coupon Added successfully!", "success");
          setSubmitBtn(title);
          onClose();
        });
      } 
    } catch (error) {
      console.log(error)
      showNotification("Error", "Failed to add the coupon. Please try again.", "error");
    }
  };
  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer max-w-md" style={{ alignItems: alignLeft ? "flex-start" : "center" }}>
        <h2 className="newPopUpModalTitle">{title}</h2>
        <div className="couponPopUpModalContent">
          <h4 className="quotePrimaryTitle">Discount Code</h4>
          <div className="orderDiscountCodeWrapper">
            <FormTextInput placeholder={"Discount code"} copy={true}
              copyIcon value={discountCode} onChange={setDiscountCode} />
            <NewButton text={"Generate Code"} back={true} icon={false} onClick={() => handleGenerateDiscount()} whiteBtn={true} />
          </div>
          <div className="orderDiscountCodeWrapper">
            <FormTextInput placeholder={"Discount (%)"} value={discount} onChange={onChangeDiscount} />
            <FormTextInput placeholder={"Usage"} value={usage} onChange={onChangeUsage} />
          </div>
          <div className="orderDiscountCodeWrapper">
            <FormTextInput placeholder={"Name (optional)"} value={name} onChange={onChangeName} />
            <FormTextInput placeholder={"Email (optional)"} value={email} onChange={onChangeEmail} />
          </div>
        </div>


        <div className="newPopUpModalTextWrap">
          <NewButton disabled={disableBtn || !discountCode || !discount} deleteBtn={deleteBtn} text={submitBtn} width="100%" onClick={btnAddCoupon} />
          <NewButton text={'Cancel'} width="100%" onClick={onClose} back sendIcon={sendIcon} icon={false} whiteBtn />
        </div>

        {showClose && <Close className="newPopUpModalCloseIcon" onClick={onClose} />}
        
      </div>
    </div>
  );
};

export default AddEditCouponPopUp;
